import { Component, OnInit } from '@angular/core';
import {
  Mode,
  ProductionModeService,
} from 'src/domains/share/app/service/production-mode/production-mode.service';
import { UserService } from 'src/domains/share/app/service/user/user.service';
import { SyncUpdateService } from 'sync-update';
import { ToastMessage, ToastModel } from 'toast';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MessageService } from 'primeng/api';
import { ClientNotificationModel } from 'src/domains/authentication/model/notifications/client-notification.model';
import { PageLoadEventService } from 'src/domains/share/app/service/page-load-event/page-load-event.service';
import { LocalStorageService } from 'reactive-localstorage';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'front';
  mode: Mode = ProductionModeService.whereAmI();
  // NOTE: dont remove userService because doesnt work correct
  constructor(
    private messageService: MessageService,
    private userService: UserService,
    private socketService: SyncUpdateService,
    private pageLoadEvent: PageLoadEventService,
  ) {}

  ngOnInit() {
    LocalStorageService.onChange('notification')
      .pipe(untilDestroyed(this))
      .subscribe((value) => {
        if (value == 'disable') {
          return;
        } else {
          this.socketService
            .getNotification()
            .pipe(untilDestroyed(this))
            .subscribe((message) => {
              message.forEach((data) => {
                const toastMessage: ToastMessage = {
                  id: String(data?.id),
                  severity: ToastModel.severityMap[data?.type],
                  summary: data?.title,
                  detail: data?.content,
                  life: 5000,
                  sticky: false,
                };
                if (value == 'sticky') {
                  toastMessage.sticky = true;
                  this.messageService.add(toastMessage);
                } else {
                  this.messageService.add(toastMessage);
                }
              });
            });
        }
      });

    if (this.mode === 'hamsaz') {
      // clarity
      // (function (c, l, a, r, i, t, y) {
      //   c[a] = c[a]  function () { (c[a].q = c[a].q  []).push(arguments) };
      //   t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      //   y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      // })(window, document, "clarity", "script", "km5dvisv3f");
      // goftino
      // @ts-ignore
      // !(function () {
      //   const i = 'K7dvq3',
      //     a = window,
      //     d = document;
      //   function g() {
      //     const g = d.createElement('script'),
      //       s = 'https://www.goftino.com/widget/' + i,
      //       l = localStorage.getItem('goftino_' + i);
      //     (g.async = !0), (g.src = l ? s + '?o=' + l : s);
      //     d.getElementsByTagName('head')[0].appendChild(g);
      //   }
      //   'complete' === d.readyState
      //     ? g()
      //     : a.attachEvent
      //       ? a.attachEvent('onload', g)
      //       : a.addEventListener('load', g, !1);
      // })();
    }
  }
  iconConvertor(item: string) {
    return ClientNotificationModel.notifType[item];
  }
}
